import * as React from 'react';
import { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

export const Yes: ReactElement = <FormattedMessage id="label.yes"/>;
export const No: ReactElement = <FormattedMessage id="label.no"/>;
